import type { FC } from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { Button, Text } from 'react-native-paper';

import { SpeechBubbleCheckedImage } from '@/assets';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';
import { useAppTheme } from '@/styles/hooks/useAppTheme';
import type { AppTheme } from '@/styles/theme';

const makeStyles = (theme: AppTheme) =>
  StyleSheet.create({
    container: {
      backgroundColor: theme.colors.surfaceContainerLow,
      padding: 16,
      flexDirection: 'column',
      alignItems: 'center',
      gap: 32,
      marginTop: 16
    },
    text: { textAlign: 'center' }
  });

type EmailVerificationSuccessViewProps = {
  onClose: () => void;
};

export const EmailVerificationSuccessView: FC<
  EmailVerificationSuccessViewProps
> = ({ onClose }) => {
  const theme = useAppTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);
  const { t } = useTranslation(LocalizationNameSpace.VERIFICATION, {
    keyPrefix: 'sheets.successMail'
  });

  return (
    <View style={styles.container}>
      <SpeechBubbleCheckedImage height={172} />
      <Text variant="bodyLarge" style={styles.text}>
        {t('text')}
      </Text>
      <Button mode="contained" onPress={onClose}>
        {t('confirm')}
      </Button>
    </View>
  );
};
